import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from 'ui-kit-takeat';
import { Container } from './styles';
import { NavBar } from './styles';
import { FaCashRegister } from 'react-icons/fa';
import { FaFilterCircleDollar } from 'react-icons/fa6';
import { HiDocumentDownload, HiDocumentRemove } from 'react-icons/hi';
import { PageTitle } from '~/components/PageTitle';

function Header() {
  const location = useLocation();
  const [pathname, setPathname] = useState('');

  useEffect(() => {
    setPathname(location.pathname);
  }, [location.pathname]);

  function getTitleName(path) {
    switch (path) {
      case '/fiscal/manifest':
        return 'Manifesto de notas';

      case '/fiscal/entries':
        return 'Entrada de notas';

      case '/fiscal/issued':
        return 'Notas Emitidas';

      case '/fiscal/avulsa':
        return 'Notas Emitidas';

      case '/fiscal/returned':
        return 'Notas Devolvidas';

      default:
        break;
    }
  }

  return (
    <Container>
      <div>
        <PageTitle>{getTitleName(pathname)}</PageTitle>
      </div>

      <NavBar>
        <Link to={'/fiscal/issued'}>
          <Button
            title="Notas Emitidas"
            icon={<HiDocumentDownload />}
            inverted={pathname !== '/fiscal/issued'}
            onClick={() => {}}
          />
        </Link>
        <Link to={'/fiscal/manifest'}>
          <Button
            title="Manifesto de Notas"
            icon={<FaCashRegister />}
            inverted={pathname !== '/fiscal/manifest'}
            onClick={() => {}}
          />
        </Link>
        <Link to={'/fiscal/entries'}>
          <Button
            title="Entrada de Notas"
            icon={<FaFilterCircleDollar />}
            inverted={pathname !== '/fiscal/entries'}
            onClick={() => {}}
          />
        </Link>
        <Link to={'/fiscal/returned'}>
          <Button
            title="Notas Devolvidas"
            icon={<HiDocumentRemove />}
            inverted={pathname !== '/fiscal/returned'}
            onClick={() => {}}
          />
        </Link>
      </NavBar>
    </Container>
  );
}

export default Header;
